import sh1 from './CAM_S_06.png';
import sh2 from './GG_S_0.png';
import sh3 from './GG_S_03.png';
import sh4 from './RR_S_0.png';
import sh5 from './RR_S_02.png';
import sh6 from './RR_S_07.png';
import sh7 from './sweet-circuuts.png';
import sh8 from './sweet-circuuts2.png';


let shoes = [
  {'url':sh1, 'num': 0},
  {'url':sh2, 'num': 1},
  {'url':sh3, 'num': 2},
  {'url':sh4, 'num': 3},
  {'url':sh5, 'num': 4},
  {'url':sh6, 'num': 5},
  {'url':sh7, 'num': 6},
  {'url':sh8, 'num': 7},

];
export default shoes;



// WEBPACK FOOTER //
// ./src/img/clothes/shoes/shoes.js